import manageGroupUrl from './manageGroup.html';
import ManageGroupCtrl from './ManageGroupCtrl';

export default {
  controller: ManageGroupCtrl,
  controllerAs: 'ctrl',
  templateUrl: manageGroupUrl,
  bindings: {
    group: '<',
    previousState: '<',
    tab: '@',
  },
};
